import {
    type OnOpenChangeData,
    type OpenPopoverEvents,
    Popover,
    PopoverSurface,
    PopoverTrigger,
    Tooltip,
} from '@fluentui/react-components';
import type { Column } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import { useStyles } from '../styles.js';
import { DataTableHeaderButton } from '../trigger/index.js';

export type DataTableHeaderCellProps<TData, TValue> = {
    column: Column<TData, TValue>;
    title: ReactNode;
    open: boolean;
    openPopover: () => void;
    closePopover: () => void;
    onOpenChange: (event: OpenPopoverEvents, data: OnOpenChangeData) => void;
    tooltip?: ReactNode;
    popover: ReactNode;
};

export function DataTableHeaderCell<TData, TValue>({
    column,
    title,
    open,
    openPopover,
    closePopover,
    onOpenChange,
    tooltip,
    popover,
}: DataTableHeaderCellProps<TData, TValue>) {
    const styles = useStyles();

    if (!column.getCanSort()) {
        return title;
    }

    return (
        <div className={styles.headerCell}>
            <Popover
                closeOnScroll
                open={open}
                onOpenChange={onOpenChange}
                positioning={{
                    autoSize: true,
                    align: 'start',
                }}
            >
                <PopoverTrigger>
                    <div className={styles.popoverTrigger}>
                        {tooltip ? (
                            <Tooltip content={<div>{tooltip}</div>} relationship="label">
                                <DataTableHeaderButton
                                    column={column}
                                    title={title}
                                    onClick={openPopover}
                                    closePopover={closePopover}
                                />
                            </Tooltip>
                        ) : (
                            <DataTableHeaderButton
                                column={column}
                                title={title}
                                onClick={openPopover}
                                closePopover={closePopover}
                            />
                        )}
                    </div>
                </PopoverTrigger>

                <PopoverSurface className={styles.popoverSurface}>{popover}</PopoverSurface>
            </Popover>
        </div>
    );
}
